export default {
  id: 138,
  title: 'Target #138 - Lotus',
  url: 'https://cssbattle.dev/play/138',
  colors: ['#926927', '#6D480A', '#FFFFFF'],
  solution:
    '<a a><a b><a c><style>[a],[b]{background:#6d480a}body{background:#926927}a{position:fixed;width:100px;height:100px;border-radius:0 9in;top:120;left:100;transform-origin:bottom right}[b]{transform:rotate(90deg)}[c]{top:121;background:#fff;transform:rotate(45deg)}</style>',
}
